import { Component, ViewChild, ElementRef,OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { DataService } from '../data.service';
import { ValidationService } from '../validation.service';
import * as Chart from 'chart.js';
import { environment } from '../../environments/environment';
declare var $: any;
declare global { interface Window { analytics: any; } }
import html2canvas from 'html2canvas';

@Component({
  selector: 'app-atedresult',
  templateUrl: './atedresult.component.html',
  styleUrls: ['./atedresult.component.css']
})
export class AtedresultComponent implements OnInit {

  MapLoad=true;
  lat :number=0;
  long :number=0;
  calcData: any;
  ctx:any;
  GBPValue:'';
  stampDutyLandTax:any;
  today = new Date();
  effectiveRate="";
  propertyvalueid:any;
  propertydropdown: any=[];
  atedchargevalue:any;
  constructor(public validation: ValidationService,
    private dataService: DataService,
    private router: Router,
    private titleService: Title) {
    this.titleService.setTitle('ATED Calculator — Report | Adventum');
    this.calcData = JSON.parse(localStorage.getItem('calcData'));
    if(!this.dataService.EmptyNullOrUndefined(this.calcData.lat)){
      this.lat=this.calcData.lat; 
    } 
    if(!this.dataService.EmptyNullOrUndefined(this.calcData.long)){
      this.long=this.calcData.long; 
    } 
  }
    ngAfterViewInit(): void {
      if(!this.calcData.reportSavedOnServer && !this.validation.isNullEmptyUndefined(sessionStorage.getItem('UserId'))){
        this.reportSaveToServer();
      }
    }
  
    ngOnInit(): void {
      this.calcData = JSON.parse(localStorage.getItem('calcData'));
      this.propertyvalueid=this.calcData.PropertyValue;
      this.atedchargevalue = this.calcData.ATEDCharge;
    }

  
    startagain(): void{
      this.calcData.reportSavedOnServer=false;
      localStorage.setItem("calcData",JSON.stringify(this.calcData));
      // localStorage.clear();
      this.router.navigate(['/']);
    }
  
    
    printScreen() {
      window.print();
    }
    reportSaveToServer(){
      setTimeout(() => {
        if (!this.calcData.reportSavedOnServer && !this.validation.isNullEmptyUndefined(sessionStorage.getItem('UserId'))) {
          $(".noprint").addClass("displaynone");
          const data = document.getElementById('contentToConvert');
          html2canvas(data,
            {
              scrollY: -window.scrollY,
              logging: true,
              useCORS: true,
              allowTaint: true
            }).then(canvas => {
              let contentDataURL = canvas.toDataURL('image/png');
              contentDataURL=contentDataURL.replace("data:image/png;base64,","");
              const Data = { "UserId": sessionStorage.getItem('UserId'), "CalculatorId": localStorage.getItem('CalculatorType').toString(), "ResultImageBase64String": contentDataURL };
              const Response = this.dataService.PostAdventumRequest('v1/saveuserresult', Data).subscribe((response) => {
                this.calcData.reportSavedOnServer=true;
                localStorage.setItem("calcData",JSON.stringify(this.calcData));
              });
            });
            $(".noprint").removeClass("displaynone");
        }
      }, 5000);
      
    }
  

}
